import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import grid from '../../images/grid.png';
import mobilepartners from '../../images/mobilepartners.png';
import UIConfigurationImage from '../../images/ui-configurations@2x.png';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <div>
      <h2>{`Customization`}</h2>
      <p>{`Customizing your GIPHY mobile SDK integration`}</p>
      <img src={mobilepartners} width="860" />
      <p>{`As slick and finely-tuned as the templates are, we know many developers want to have more control over the look and feel of the GIPHY search experience in their app. We made some adjustments to the mobile SDK to give teams the flexibility to fit GIPHY seamlessly into their app, while still making integration a lot easier than starting from scratch.`}</p>
      <p>{`With the latest release, you can leverage the grid component of the GIPHY SDK, which makes it easy to populate a grid of gifs and stickers with search results or trending feeds. The component takes care of requesting content from the GIPHY API, loading, caching, and rendering images in a customizable grid, and leaves the rest of the experience up to you.`}</p>
      <p>{`We affectionately refer to this component as "Grid-Only". Thus, to enable the GIPHY experience, the rest of the UI (text fields, buttons, etc.) is provided and wired up by you.`}</p>
      <h2>{`Choosing the right solution for your app`}</h2>
      <p>{`We offer two solutions for the SDK user interface: pre-built templates which handle the entirety of the GIPHY experience, and a Grid-Only implementation which allows for endless customization. See the section below to figure out which solution is best for your app.`}</p>
      <h3>{`Templates`}</h3>
      <ul>
        <li parentName="ul">
          <p parentName="li">{`The templates take care of all things GIPHY, including obtaining user input and displaying search results. Your app just presents the GIPHY view (`}<inlineCode parentName="p">{`GiphyViewController`}</inlineCode>{` in the case of iOS, or `}<inlineCode parentName="p">{`GiphyDialogFragment`}</inlineCode>{` in the case of Android) and we take care of the rest. The experiences provided by the templates are battle-tested and informed by our years of experience serving GIFs on mobile.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`The templates come in "carousel" or "waterfall" layouts, as well as light and dark color schemes. Give the example app a spin to see the different customization options in action.`}</p>
        </li>
      </ul>
      <img src={UIConfigurationImage} width="860" />
      <h3>{`Grid-Only`}</h3>
      <ul>
        <li parentName="ul">
          <p parentName="li">{`We recommend going with grid-based only if the templates aren't flexible enough for your app's UI. While you have more control over the design, it's a bit less plug-and-play.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Opting for the grid-based solution requires that you provide your own search field to obtain text input from the user, provide controls to allow users to select media types (if applicable for your experience), and update the grid's content in response to user interaction or searches.`}</p>
        </li>
      </ul>
      <img src={grid} width="860" />
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      